import axios from "../plugins/axios";

export const getAllTransactions = async (payload) => {
    const response = await axios.post(`/api/transactions/search?page=${payload?.page}&limit=${payload?.limit}`, payload);
    return response
}

export const getDailyTransactions = async (payload) => {
    const response = await axios.post(`/api/transactions/daily`, payload);
    return response;
}

export const getRangeTransactions = async (payload) => {
    const response = await axios.post(`/api/transactions/range`, payload);
    return response;
}